<template>
  <span>
    <Dialog
      class="test-box"
      header="Exportar Notas Fiscais Maior Período"
      :visible.sync="showExportarNfsePeriodo"
      :contentStyle="{ overflow: 'visible', width: '1000px' }"
      :modal="true"
      :closable="false"
    >
      <div class="container">
        <div id="topo" class="row" style="margin-right: 380px;">
          <div class="col-md-4 col-lg-6 mb-3">
            <span class="p-fluid">
              <Calendar
                id="dataIni"
                name="dataIni"
                v-model="dataFatoGeradorIni"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                placeholder="Data Inicial*"
                @keyup.enter="pesquisar"
                v-maska="'##/##/####'"
              />
            </span>
          </div>
          <div class="col-md-4 col-lg-6 mb-3">
            <span class="p-fluid">
              <Calendar
                id="dataFin"
                name="dataFin"
                v-model="dataFatoGeradorFim"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                placeholder="Data Final*"
                @keyup.enter="pesquisar"
                v-maska="'##/##/####'"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12 mb-3">
            <span class="p-fluid">
              <AutoComplete
                id="tomador"
                v-model="selectedPessoa"
                :dropdown="true"
                :suggestions="filteredPessoas"
                @complete="searchPessoa($event)"
                @keyup.enter="pesquisar"
                field="detail"
                placeholder="Pesquisar CPF/CNPJ/Nome Tomador"
                style="width: 50vw; margin-right: 140px;"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12 mb-3">
            <span class="p-fluid">
              <AutoComplete
                id="servico"
                v-model="selectedServico"
                :dropdown="true"
                :suggestions="filteredServicos"
                field="detail"
                @complete="searchServico($event)"
                placeholder="Pesquisar Serviço"
                style="width: 50vw; margin-right: 140px;"
              >
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 50vw">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>
        </div>
          <div class="row">
            <div class="col-md-12 mb-2">
              <span class="p-fluid">
                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                  placeholder="Selecione uma Situação"
                  style="width: 50vw; margin-right: 140px;" />
              </span>
            </div>
        </div>

        <Toast style="width: 700px;" position="bottom-center" group="bc">
          <template #message="slotProps">
            <div class="flex flex-column">
              <div class="text-center">
                <i class="pi pi-info-circle" style="font-size: 3rem"></i>
                <h4 style="font-weight: bold">{{slotProps.message.summary}}</h4>
                <p class="msg-export">{{slotProps.message.detail}}</p>
                <p class="msg-export">
                  Assim que a exportação for finalizada, você receberá um e-mail de confirmação.
                </p>
              </div>
            </div>
          </template>
        </Toast>

        <div style="margin-top: 20px"></div>
        <TabView>
          <TabPanel header="Status de Exportações">
            <DataTable style="min-width: 880px" :value="exportsList" :paginator="true" :rows="4" class="p-datatable-responsive"
              :autoLayout="true">
              <Column headerStyle="width: 12em" bodyStyle="text-align: center" header="Exportação">
                <template #body="slotProps">
                  <Button 
                    :disabled="slotProps.data.status !== 'Concluído'" 
                    type="button" 
                    icon="pi pi-download" 
                    style="margin-right: .5em" 
                    @click="downloadExportacao(slotProps.data.id)"
                  >
                  </Button>
                </template>
              </Column>
              <Column field="dataSolicitacaoFormatada" header="Data Solicitação"></Column>
              <Column field="dataInicial" header="Data Início"></Column>
              <Column field="dataFinal" header="Data Término"></Column>
              <Column field="status" header="Status"></Column>
            </DataTable>
          </TabPanel>
        </TabView>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="solicitarExportacao()"
              href="#topo"
              type="button"
              label="Exportar Notas Fiscais"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-download"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              @click="showExportarNfsePeriodo = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { maska } from 'maska'
import ContribuinteServicoService from "@/services/tributario/contribuinte.servico.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import PessoaService from "@/services/nfse/pessoa.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";

export default {
  directives: { maska },
  name: "ExportarNfseMaiorPeriodo",

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;

    this.consultaSolicitacoes();

    this.$root.$on("notaFiscal:exportarMaiorPeriodo", () => {
      this.showExportarNfsePeriodo = true;
      this.dataFatoGeradorIni = null;
      this.dataFatoGeradorFim = null;
      this.selectedPessoa = null;
      this.filteredPessoas = null;
      this.selectedServico = null;
      this.filteredServicos = null;
    });
  },

  data() {
    return {
      loading: false,
      showExportarNfsePeriodo: false,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedPessoa: null,
      filteredPessoas: null,
      selectedServico: null,
      filteredServicos: null,
      notaAvulsa: null,
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituida", key: "S" }
      ],
      exportsList: []
    };
  },

  methods: {
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(
          event.query,
          ""
        );
      }, 550);
    },
    searchServico(event) {
      if (this.currentUser.configuracao.idBolHabilitaCnaeNf == "N") {
        if (this.notaAvulsa) {
          // Se for nota avulsa exibir todos os serviços
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllNfAvulsa(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        } else {
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        }
      }
    },
    consultaSolicitacoes(){
      NotaFiscalService.findSolicitExportNfse(
        this.currentUser.contribuinte.idContribuinte
      ).then(
        (data) => {
          this.exportsList = data.data;
          console.log(this.exportsList);
        }
      )
    },
    solicitarExportacao() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      } else if(!this.filtroSituacao && !this.filtroSituacao.key){
        msg = "É necessário informar uma Situação!"
      }else{
        const dataIni = new Date(this.dataFatoGeradorIni);
        const dataFim = new Date(this.dataFatoGeradorFim);
        const diffTime = dataFim - dataIni;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays < 90) {
          msg = "Para exportações de até 90 dias, é mais viável utilizar a Exportação Normal.";
        }
      }

      if (!msg) {
        this.$toast.add({
          group: "bc",
          severity: "info",
          summary: "Exportação em Andamento",
          detail:
            "A exportação foi iniciada e será processada em fila. Esse processo pode levar algumas horas para ser concluído, se houver grande volume de dados e à execução em rotina.",
          life: 15000,
        });

        this.processando(true);
        console.log(this.filtroSituacao);
        console.log(this.filtroSituacao.key);
        console.log(this.dataFatoGeradorFim);
        NotaFiscalService.solicitarExportacoNfse(
          this.currentUser.contribuinte.idContribuinte,
          this.currentUser.usuario.idUsuario,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : ""),
          (this.selectedServico && this.selectedServico.idServico ? this.selectedServico.idServico.idServicoItem : ""),
          (this.filtroSituacao && this.filtroSituacao.key != "T" ? this.filtroSituacao.key : null )
        )
          .then(
            (data) => {
              this.$root.$emit("alert:success", "Exportação Solicitada com Sucesso!");
              console.log(data);
              this.consultaSolicitacoes();
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    downloadExportacao(idSolicitacao){
      ReportService.downloadExportacoesMaiorPer(
        idSolicitacao,
        this.$root
      ).then(
          (data) => {
            console.log(data);
          },
          (error) => {
            console.log(error);
          }
      ).then(() => {
          this.processando(false);
        });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },
};
</script>

<style scoped>
  .msg-export{
    margin-top: 10px;
    text-align: left;
  }
</style>